module.exports = __webpack_public_path__ + "static/media/(000004).05a8fabf.jpg";